import { FC, SVGProps } from 'react';

const PlayCircle: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 25,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.37533 11.6251L11.4378 9.02091C11.6323 8.89591 11.7295 8.7223 11.7295 8.50008C11.7295 8.27786 11.6323 8.10425 11.4378 7.97925L7.37533 5.37508C7.16699 5.23619 6.95519 5.22578 6.73991 5.34383C6.52463 5.46189 6.41699 5.64591 6.41699 5.89591V11.1042C6.41699 11.3542 6.52463 11.5383 6.73991 11.6563C6.95519 11.7744 7.16699 11.764 7.37533 11.6251ZM8.50033 16.8334C7.34755 16.8334 6.26421 16.6147 5.25033 16.1772C4.23644 15.7397 3.35449 15.1459 2.60449 14.3959C1.85449 13.6459 1.26074 12.764 0.823242 11.7501C0.385742 10.7362 0.166992 9.65286 0.166992 8.50008C0.166992 7.3473 0.385742 6.26397 0.823242 5.25008C1.26074 4.23619 1.85449 3.35425 2.60449 2.60425C3.35449 1.85425 4.23644 1.2605 5.25033 0.822998C6.26421 0.385498 7.34755 0.166748 8.50033 0.166748C9.6531 0.166748 10.7364 0.385498 11.7503 0.822998C12.7642 1.2605 13.6462 1.85425 14.3962 2.60425C15.1462 3.35425 15.7399 4.23619 16.1774 5.25008C16.6149 6.26397 16.8337 7.3473 16.8337 8.50008C16.8337 9.65286 16.6149 10.7362 16.1774 11.7501C15.7399 12.764 15.1462 13.6459 14.3962 14.3959C13.6462 15.1459 12.7642 15.7397 11.7503 16.1772C10.7364 16.6147 9.6531 16.8334 8.50033 16.8334Z"
        fill="#007A5A"
      />
    </svg>
  );
};

export default PlayCircle;
